import React from "react";
import "@ant-design/compatible/assets/index.css";
import { Select, Form } from "antd";
const { Option } = Select;

const SelectFormItem = ({
  formItem,
  selectData = [],
  selectChange,
  placeholder,
}) => {
  const selectOptions = selectData?.map((data) => (
    <Option key={data._id}>
      {data.name} - {data.user_name} - {data.email}
    </Option>
  ));
  return (
    <Form.Item
      label={formItem.label}
      name={formItem.name}
      rules={[
        {
          required: true,
          message: formItem.message,
        },
      ]}
    >
      <Select
        showSearch
        placeholder={placeholder}
        onChange={selectChange.selectOneChange}
        optionFilterProp="children"
        notFoundContent={null}
      >
        {selectOptions}
      </Select>
    </Form.Item>
  );
};

export default SelectFormItem;
